import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  FaLaptopCode,
  FaGlobe,
  FaMobileAlt,
  FaCloud,
  FaPaintBrush,
  FaShieldAlt,
  FaBrain,
  FaCheckCircle,
  FaServer,
} from 'react-icons/fa';
import bgImage from '../assets/ai1.png';

const services = [
  {
    title: 'AI & Machine Learning',
    icon: <FaBrain />,
    path: '/ai',
    features: [
      'Custom LLM integrations',
      'Natural language processing',
      'Image/video recognition',
      'Predictive analytics',
      'AI-driven automation',
    ],
  },
  {
    title: 'Web & Software Development',
    icon: <FaLaptopCode />,
    path: '/custom-software',
    features: [
      'Tailored desktop & web applications',
      'Workflow automation',
      'Database-driven tools',
     'Responsive & interactive UIs',
    'Advanced SEO & accessibility',
      'GraphQL & REST APIs',
    ],
},

  {
    title: 'Mobile App Development',
    icon: <FaMobileAlt />,
    path: '/mobile-app',
    features: [
      'Cross-platform solutions',
      'Native app development',
      'Progressive Web Apps (PWA)',
      'Hybrid app development',
      'Push Notifications',
      'App Store Deployment',
    ],},
  {
      title: 'Managed IT Services',
      icon: <FaServer />,
      path: '/managed-it',
      features: [
        '24/7 Network Monitoring',
        'Proactive Maintenance & Updates',
        'Cybersecurity & Data Backup',
        'Cloud Infrastructure Management',
        'Compliance & Regulatory Support',
      ],
    
    
  },

  {
    title: 'Cloud Solutions',
    icon: <FaCloud />,
    path: '/cloud',
    features: [
     'Serverless & containerized systems',
      'CI/CD pipelines (GitHub, GitLab)',
      'Multi-cloud deployment (AWS, Azure, GCP)',
      'Infrastructure as Code (Terraform)',
    ],
  },
  {
    title: 'Cybersecurity',
    icon: <FaShieldAlt />,
    path: '/cybersecurity',
    features: [
      'End-to-end encryption',
      'Threat modeling',
      'Zero-trust architecture',
      'Regular audits & testing',
      
      'Firewall & Monitoring',
    ],
  },
  


];

const Services = () => {
  const containerStyle = {
    minHeight: '100vh',
    padding: '80px 20px',
    color: '#fff',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundAttachment: 'fixed',
    backgroundImage: `
      linear-gradient(rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.85)),
      url(${bgImage})
    `,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    textAlign: 'center',
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: '800',
    marginBottom: '20px',
    textShadow: '0 2px 10px rgba(0,0,0,0.6)',
   color: '#8f69c8',
  };

  const descStyle = {
    fontSize: '1.25rem',
    maxWidth: '850px',
    margin: '0 auto 60px',
    color: '#cbd5e1',
    lineHeight: '1.8',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '35px',
    maxWidth: '1200px',
    margin: '0 auto 60px',
  };

  const cardStyle = {
    background: 'rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(12px)',
    borderRadius: '18px',
    padding: '35px 30px',
    boxShadow: '0 10px 35px rgba(0, 0, 0, 0.3)',
    color: '#fff',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    textDecoration: 'none',
  };

  const iconWrapper = {
    background: 'linear-gradient(135deg, #60a5fa, #9333ea)',
    width: '65px',
    height: '65px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.9rem',
    color: 'white',
    marginBottom: '18px',
    boxShadow: '0 6px 18px rgba(147, 51, 234, 0.3)',
  };

  const listStyle = {
    listStyle: 'none',
    padding: 0,
    marginTop: '18px',
    fontSize: '1rem',
  };

  const listItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
  };

  const checkIconStyle = {
    color: '#3b82f6',
    fontSize: '1.15rem',
    marginRight: '10px',
  };

  const buttonStyle = {
    background: 'linear-gradient(45deg, #3b82f6, #9333ea)',
    border: 'none',
    color: 'white',
    fontWeight: '700',
    fontSize: '1.1rem',
    padding: '16px 42px',
    borderRadius: '30px',
    cursor: 'pointer',
    boxShadow: '0 6px 18px rgba(59, 130, 246, 0.4)',
    transition: 'transform 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>Our Expert Services</h2>
      <p style={descStyle}>
        Empowering your digital journey with cutting-edge solutions in AI, software engineering, cloud platforms,
        and user-first design. We architect, build, and scale intelligent systems for the modern world.
      </p>

      <div style={gridStyle}>
        {services.map((service, index) => (
          <Link to={service.path} key={index} style={{ textDecoration: 'none' }}>
            <motion.div
              style={cardStyle}
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div style={iconWrapper}>{service.icon}</div>
              <h3 style={{ color: '#fff', marginBottom: '10px' }}>{service.title}</h3>
              <ul style={listStyle}>
                {service.features.map((feature, idx) => (
                  <li key={idx} style={listItemStyle}>
                    <FaCheckCircle style={checkIconStyle} /> {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          </Link>
        ))}
      </div>

      <Link to="/services">
        <button
          style={buttonStyle}
          onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
          onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        >
          Explore All Services
        </button>
      </Link>
    </div>
  );
};

export default Services;
